import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { Card } from '../../../Card'
import PassportLogo from '../../../../../../assets/logo-sm.png'
import starImage from '../../../../../../assets/svg/Star.svg'
import starGoldImage from '../../../../../../assets/svg/StarGold.svg'

import useFollowHandler from './hooks/useFollowHandler'

import styles from './styles.module.scss'

const CommunityCard = ({ id, name, description, follow, logo }) => {
  const history = useHistory()
  const { star, followHandler } = useFollowHandler(id, name, follow)

  const handleCardClick = useCallback(() => {
    history.push(`/community/${id}/events`)
  }, [history, id])

  const handleStarClick = useCallback(
    e => {
      e.stopPropagation()
      followHandler()
    },
    [followHandler]
  )

  return (
    <Card
      onClick={handleCardClick}
      className={styles.communityCard}
      data-testid='community-card'
    >
      <div className={styles.communityHeader}>
        <img
          src={logo ? logo : PassportLogo}
          className={styles.communityLogo}
          alt={name || 'Community'}
          data-testid='community-logo'
        />

        <img
          src={star ? starImage : starGoldImage}
          className={styles.communityStar}
          onClick={handleStarClick}
          alt='Follow/Unfollow'
          data-testid='follow-community-button'
        />
      </div>

      <div className={styles.communityContent}>
        <h3 className={styles.communityName} data-testid='community-name'>
          {name || 'Community'}
        </h3>

        <div className={styles.communityDescription}>
          <p
            className={styles.communityText}
            data-testid='community-description'
          >
            {description?.length > 100
              ? `${description.slice(0, 100)}...`
              : description}
          </p>
        </div>
      </div>
    </Card>
  )
}

export default CommunityCard
